document.addEventListener('DOMContentLoaded', () => {
  const headerCartIcon = document.querySelector('.header-actions__cart-icon');
  if (!headerCartIcon) return;

  headerCartIcon.addEventListener('click', (e) => {
    // Hledáme hlavní ATC tlačítko na produktové stránce
    const mainAddToCartBtn = document.querySelector(
      'product-form-component [ref="addToCartButton"], ' +
      'product-form [name="add"], ' +
      '.product-form__submit'
    );

    if (mainAddToCartBtn && !mainAddToCartBtn.disabled) {
      // Produktová stránka — klikni na hlavní ATC tlačítko okamžitě
      e.preventDefault();
      e.stopPropagation();
      mainAddToCartBtn.click();
    }
    // Jinak — výchozí chování (přechod na /cart, homepage atd.)
  });
});
